<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
          <div class="hidden">
            <a-form-item label="id" name="id">
                <a-inputNumber style="width:100%" v-model:value="form.id"/>
            </a-form-item>
        </div>
        <a-row :gutter="[24,8]">
            <a-col :span="24">
                <a-form-item label="项目图片" name="picture">
                    <img-upload v-model:value="form.picture" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="项目名称" name="projectName">
                    <a-input v-model:value="form.projectName" placeholder="请输入项目名称" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="项目领域(高新领域)" name="projectField">
                    <DictSelect v-model:value="form.projectField" :dict-name="innovation.TECHNICAL_FIELD" placeholder="请选择" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="项目阶段" name="projectStage">
                    <DictSelect v-model:value="form.projectStage" :dict-name="financeDict.PROJECTSTAGE" placeholder="请选择" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="项目地区" name="prov">
                    <city-select v-model:prov="form.prov" v-model:city="form.city" v-model:dist="form.dist"
          placeholder="请选择省/市/区" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="项目详细地址" name="projectArea">
                    <a-input v-model:value="form.projectArea" placeholder="请输入项目地区" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="项目联系人" name="contacts">
                    <a-input v-model:value="form.contacts" placeholder="请输入项目联系人" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="联系人电话" name="contactNumber">
                    <a-input v-model:value="form.contactNumber" placeholder="请输入联系人电话" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="融资金额(万元)" name="financingAmount">
                    <a-input-number v-model:value="form.financingAmount" placeholder="请输入融资金额(万元)" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="企业估值(万元)" name="enterpriseValuation">
                    <a-input-number v-model:value="form.enterpriseValuation" placeholder="请输入企业估值(万元)" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="出让股份(%)" name="transferShares">
                    <a-input-number v-model:value="form.transferShares" placeholder="请输入出让股份(%)" />
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item label="项目概述" name="projectOverview">
                    <a-textarea v-model:value="form.projectOverview" placeholder="请输入项目内容"
                        :auto-size="{ minRows: 5, maxRows: 6 }" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="商业计划书" name="businessPlan">
                    <file-upload v-model:value="form.businessPlan" />
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item label="备注" name="remark">
                    <a-textarea v-model:value="form.remark" placeholder="请输入备注"
                        :auto-size="{ minRows: 5, maxRows: 6 }" />
                </a-form-item>
            </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {financeProject} from "@/api/finance";
import {innovation,financeDict} from "@/config/variableConfig";
import DictSelect from "@/components/other/DictSelect";

export default {
    name: "AddOrEditModal",
    components: {DictSelect},

    mixins: [formMixin],
    data() {
        return {
          innovation,
          financeDict,
          form: {
              id: null,
              picture: null,
              projectName: null,
              projectField: null,
              projectStage: null,
              prov: null,
              city: null,
              dist: null,
              projectArea: null,
              contacts: null,
              contactNumber: null,
              financingAmount: null,
              enterpriseValuation: null,
              transferShares: null,
              projectOverview: null,
              businessPlan: null,
              remark: null,
          },
          rules: {
                  id: [],
                  picture: [],
                  projectName: [dataCheck.required({})],
                  projectField: [dataCheck.required({})],
                  projectStage: [dataCheck.required({})],
                  prov: [dataCheck.required({})],
                  city: [dataCheck.required({})],
                  dist: [dataCheck.required({})],
                  projectArea: [dataCheck.required({})],
                  contacts: [dataCheck.required({})],
                  contactNumber: [dataCheck.required({}),dataCheck.phone],
                  financingAmount: [dataCheck.required({type:'number'}),dataCheck.number],
                  enterpriseValuation: [dataCheck.required({type:'number'}),dataCheck.number],
                  transferShares: [dataCheck.required({type:'number'}),dataCheck.number],
                  projectOverview: [dataCheck.required({})],
                  businessPlan: [],
                  remark: [],
          },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                if (this.form.id) {
                    return financeProject.edit
                } else {
                    return financeProject.add
                }
            },
        },
    mounted() {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>
